import * as React from "react";
import {
  CaregiverNotificationSettings,
  CaregiverNotificationSettingsCategories,
} from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppList, AppListDivider } from "./Generic/AppList";
import SwitchListItem from "./Generic/SwitchListItem/SwitchListItem";
import GenericSettingsScreen from "./GenericSettingsScreen";

interface SettingsNotificationsScreenProps {
  notificationSettings: CaregiverNotificationSettings;
  onChange: (value: CaregiverNotificationSettings) => void;
  onClickGoBack: () => void;
}

export class SettingsNotificationsScreen extends React.Component<SettingsNotificationsScreenProps> {
  constructor(props: SettingsNotificationsScreenProps) {
    super(props);
  }

  checkboxCallback = (
    update: (
      value: CaregiverNotificationSettingsCategories,
      checked: boolean
    ) => CaregiverNotificationSettingsCategories
  ): ((checked: boolean) => void) => {
    return (checked: boolean) => {
      const newNotificationSettings: CaregiverNotificationSettings = {
        pushNotificationsEnabled: this.props.notificationSettings.pushNotificationsEnabled,
        categories: update(this.props.notificationSettings.categories, checked),
      };
      this.props.onChange(newNotificationSettings);
    };
  };

  handlePushNotificationsEnabledChange = (checked: boolean) => {
    this.props.onChange({
      ...this.props.notificationSettings,
      pushNotificationsEnabled: checked,
    });
  };

  render() {
    return (
      <GenericSettingsScreen
        title={translate(STRINGS.NOTIFICATIONS)}
        onClickGoBack={this.props.onClickGoBack}
      >
        <div style={{ padding: "6px 0" }}>
          <SwitchListItem
            checkedLabel={translate(STRINGS.NOTIFICATIONS_ON)}
            uncheckedLabel={translate(STRINGS.NOTIFICATIONS_OFF)}
            checked={this.props.notificationSettings.pushNotificationsEnabled}
            onChange={this.handlePushNotificationsEnabledChange}
          />
        </div>

        <AppListDivider />

        <AppList>
          <SwitchListItem
            label={translate(STRINGS.NEW_VISITS_AVAILABLE)}
            disabled={!this.props.notificationSettings.pushNotificationsEnabled}
            checked={
              this.props.notificationSettings.categories.newVisitsAvailable &&
              this.props.notificationSettings.pushNotificationsEnabled
            }
            onChange={this.checkboxCallback(
              (value, checked): CaregiverNotificationSettingsCategories => ({
                ...value,
                newVisitsAvailable: checked,
              })
            )}
          />
          <SwitchListItem
            label={translate(STRINGS.AGENCY_NOTIFICATIONS)}
            disabled={!this.props.notificationSettings.pushNotificationsEnabled}
            checked={
              this.props.notificationSettings.categories.agencyNotifications &&
              this.props.notificationSettings.pushNotificationsEnabled
            }
            onChange={this.checkboxCallback(
              (value, checked): CaregiverNotificationSettingsCategories => ({
                ...value,
                agencyNotifications: checked,
              })
            )}
          />
          <SwitchListItem
            label={translate(STRINGS.CHAT_MESSAGES)}
            disabled={!this.props.notificationSettings.pushNotificationsEnabled}
            checked={
              this.props.notificationSettings.categories.chatMessages &&
              this.props.notificationSettings.pushNotificationsEnabled
            }
            onChange={this.checkboxCallback(
              (value, checked): CaregiverNotificationSettingsCategories => ({
                ...value,
                chatMessages: checked,
              })
            )}
          />
          <SwitchListItem
            label={translate(STRINGS.TRAINING_CENTER_REMINDERS)}
            disabled={!this.props.notificationSettings.pushNotificationsEnabled}
            checked={
              this.props.notificationSettings.categories.trainingCenterReminders &&
              this.props.notificationSettings.pushNotificationsEnabled
            }
            onChange={this.checkboxCallback(
              (value, checked): CaregiverNotificationSettingsCategories => ({
                ...value,
                trainingCenterReminders: checked,
              })
            )}
          />
          <SwitchListItem
            label={translate(STRINGS.CHANGES_TO_MY_VISITS)}
            disabled={!this.props.notificationSettings.pushNotificationsEnabled}
            checked={
              this.props.notificationSettings.categories.myVisitsChanges &&
              this.props.notificationSettings.pushNotificationsEnabled
            }
            onChange={this.checkboxCallback(
              (value, checked): CaregiverNotificationSettingsCategories => ({
                ...value,
                myVisitsChanges: checked,
              })
            )}
          />
          <SwitchListItem
            label={translate(STRINGS.MY_UPCOMING_VISITS_REMINDERS)}
            disabled={!this.props.notificationSettings.pushNotificationsEnabled}
            checked={
              this.props.notificationSettings.categories.myVisitsReminders &&
              this.props.notificationSettings.pushNotificationsEnabled
            }
            onChange={this.checkboxCallback(
              (value, checked): CaregiverNotificationSettingsCategories => ({
                ...value,
                myVisitsReminders: checked,
              })
            )}
          />
        </AppList>
      </GenericSettingsScreen>
    );
  }
}
